import { useLocation } from 'react-router-dom';

import { authStore } from 'auth/authStore';
import { menuItems } from 'common/AppHeader/const';
import { getVisibleMenuItemsByRole } from 'common/AppHeader/helpers';

const useAppHeader = () => {
	const location = useLocation();

	const { account } = authStore;
	const isUserLoggedIn = account !== null;
	const userAccountName = account?.name ?? 'Guest user';
	const userRoles = account?.idTokenClaims?.roles || [];
	const paths = location.pathname.split('/');
	const visibleMenuItems = getVisibleMenuItemsByRole(menuItems, userRoles);

	const handleAuthAction = () => (isUserLoggedIn ? authStore.logout() : authStore.login());

	// Branch name is set during build in .gitlab-ci.yml
	const env = process.env.REACT_APP_ENV;
	const branchName = env !== 'prod' ? process.env.REACT_APP_BRANCH_NAME : null;

	return {
		isUserLoggedIn,
		userAccountName,
		visibleMenuItems,
		paths,
		branchName,
		handleAuthAction,
	};
};

export default useAppHeader;
